import { Component, computed, inject } from '@angular/core';
import { ColorUtilsService } from '@app/core/services/color-utils.service';
import { MapWallDisplayFacade } from '@app/features/operating-picture/map-wall-display/store';
import { TranslatePipe } from '@ngx-translate/core';

type StatusCount = {
  name: string;
  color: string;
  textColorClass: string;
  count: number;
  sortOrder: number;
};

@Component({
  selector: 'topo-alert-status-counts-widget',
  imports: [TranslatePipe],
  templateUrl: './alert-status-counts-widget.component.html',
  styleUrl: './alert-status-counts-widget.component.scss'
})
export class AlertStatusCountsWidgetComponent {
  private colorUtils = inject(ColorUtilsService);
  protected state = inject(MapWallDisplayFacade);

  protected statusCounts = computed(() => {
    const countMap = this.state.workflowStatusSummaries()?.reduce(
      (acc, { summaryByStatus }) => {
        summaryByStatus.forEach(({ name, colorCode, count, sortOrder }) => {
          if (!Boolean(acc[name])) {
            acc[name] = {
              name,
              color: colorCode,
              textColorClass: this.colorUtils.isColorLightOrDark(colorCode),
              count: 0,
              sortOrder
            };
          } else if (acc[name].sortOrder > sortOrder) {
            acc[name].sortOrder = sortOrder;
          }

          acc[name].count += count;
        });

        return acc;
      },
      {} as Record<string, StatusCount>
    );

    return Object.values(countMap).sort((a, b) => a.sortOrder - b.sortOrder);
  });
}
